@if (!badge.isPromoBadge) {
    @if (badge.shouldShow) {
        <div class="card-league">
            @if (showPrizeBoostBadge) {
                <ms-prize-boost-badge class="prize-boost-badge" />
            }
            <vn-icon class="icon-alignment" size="11" [name]="badge.icon" />
            <span class="special-card-league-text">{{ badge.title }}</span>
        </div>
    }
} @else {
    <ms-promotion-badge class="card-promotional" />
}
